//Action Types
export var NOTIFICATIONS_RESET_ACTION_TYPE = "notifications/reset";
export var NOTIFICATIONS_ADD_ALERT_ACTION_TYPE = "notifications/add_alert";
export var NOTIFICATIONS_REMOVE_ALERT_ACTION_TYPE = "notification/remove_alert";
export var NOTIFICATIONS_ADD_NOTIFICATION_ACTION_TYPE = "notifications/add_notification";
export var NOTIFICATIONS_REMOVE_NOTIFICATION_ACTION_TYPE = "notifications/remove_notification";
